import { useCallback } from 'react';

import { useProductsContext } from './ProductsContextProvider';
import { IProduct } from 'models';
import { getProducts } from 'services/products';

const useProducts = () => {
  const {
    isFetching,
    setIsFetching,
    allProducts,
    setAllProducts,
    products,
    setProducts,
    filters,
    setFilters,
  } = useProductsContext();

  const fetchProducts = useCallback(() => {
    setIsFetching(true);
    getProducts().then((products: IProduct[]) => {
      setIsFetching(false);
      setAllProducts(products);
      setProducts(products);
    });
  }, [setAllProducts, setIsFetching, setProducts]);

  const filterProducts = (filters: string[]) => {
    setIsFetching(true);

    getProducts().then((products: IProduct[]) => {
      setIsFetching(false);
      let filteredProducts;

      if (filters && filters.length > 0) {
        const activeFilter = filters[0];

        filteredProducts = products.filter((p: IProduct) =>
          String(p.categoryId ?? p.categoryName) === activeFilter
        );
      } else {
        filteredProducts = products;
      }

      setFilters(filters);
      setAllProducts(products);
      setProducts(filteredProducts);
    });
  };

  return {
    isFetching,
    fetchProducts,
    allProducts,
    products,
    filterProducts,
    filters,
  };
};

export default useProducts;
